import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * subscribe to language change from parent iframe via postMessage
 * event.data?.type = "globalLanguageChange", event.data.data = language code
 */
const subscribeToLanguageChange = (callback: (language: string) => void) => {
  const handleMessage = (event: MessageEvent) => {
    const { type, data } = event.data || {};

    if (type === 'globalLanguageChange' && data) {
      let newLanguage = data;
      // map zhCN to zh
      // Now the platform uses not standard language code, need to map to standard language code
      if (data === 'zhCN') {
        newLanguage = 'zh';
      }

      callback(newLanguage);
    }
  };

  window.addEventListener('message', handleMessage);

  // return unsubscribe function
  return () => {
    window.removeEventListener('message', handleMessage);
  };
};

/**
 * sync language from global config
 */
export const useLanguageSync = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    // listen to language change from parent iframe
    const unsubscribe = subscribeToLanguageChange((newLanguage) => {
      if (i18n.language !== newLanguage) {
        console.log('Global language change received:', newLanguage);
        i18n.changeLanguage(newLanguage);
      }
    });

    return () => {
      unsubscribe();
    };
  }, [i18n]);
};
